import { ButtonField, Icon } from '@wk/components-v3-react16';
import { useAtomValue } from 'jotai';
import React, { useState } from 'react';
import { JsonEditor, githubLightTheme } from 'json-edit-react';
import styles from './JsonViewTab.module.scss';
import { workflowAtom } from '../../atoms';

const JsonViewTab = () => {
  const workflow = useAtomValue(workflowAtom);
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopyToClipboard = async () => {
    if (!workflow) {
      return;
    }

    try {
      await navigator.clipboard.writeText(JSON.stringify(workflow));
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 1000);
    } catch (caught) {
      console.error('Failed to copy XML to clipboard:', caught);
    }
  };
  return (
    <div className={styles.jsonViewWrapper}>
      <div className={styles.header}>
        <h2>JavaScript Object Notation</h2>
        <div className={styles.actions}>
          <ButtonField type="primary">
            <button onClick={handleCopyToClipboard}>
              <Icon name={copySuccess ? 'wk-icon-check' : 'wk-icon-files'} />
            </button>
          </ButtonField>
        </div>
      </div>
      <JsonEditor
        className={styles.jsonViewContainer}
        theme={githubLightTheme}
        maxWidth={'100%'}
        enableClipboard={true}
        showArrayIndices={true}
        keySort={true}
        data={workflow}
        restrictEdit={true}
        restrictDelete={true}
        restrictAdd={true}
        collapse={1}
      />
    </div>
  );
};

export default JsonViewTab;
